import { ReactElement } from "react";
import { Summary as ReportSummary } from "@idwal/idwal-react-components";
import { selectMainShipImage } from "../../features/screeningSlice";
import { useAppSelector } from "../../redux/hooks";
import { ScreeningItem } from "../../types/Screening";

type Props = {
    data: ScreeningItem;
};

export const ScreeningSummary = (props: Props): ReactElement => {
    const { data } = props;

    const mainShipImage = useAppSelector(selectMainShipImage);

    return (
        <ReportSummary
            paragraph={data.summary_short ?? ""}
            screeningPhoto={mainShipImage}
        />
    );
};
